// src/pages/admin/LoginPage.js
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/myprvtpage");
    } catch (err) {
      setError("E-posta veya şifre hatalı.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <div style={{ marginBottom: 40, textAlign: "center" }}>
          <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 28, marginBottom: 8 }}>
            D<span style={{ color: "var(--accent)" }}>.</span>İNEL
          </div>
          <div style={{ color: "var(--muted)", fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase" }}>Admin Panel</div>
        </div>

        <div style={{ border: "1px solid var(--border)", background: "var(--card)", padding: 32 }}>
          {error && (
            <div style={{ background: "rgba(226,75,74,0.1)", border: "1px solid #E24B4A", color: "#E24B4A", padding: "10px 14px", marginBottom: 20, fontSize: 12 }}>
              {error}
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 10, letterSpacing: "0.15em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 8 }}>E-posta</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 10, letterSpacing: "0.15em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 8 }}>Şifre</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
              onKeyDown={e => e.key === "Enter" && handleSubmit(e)} />
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{ width: "100%", background: "var(--accent)", color: "#0a0a0a", border: "none", padding: "14px 0", fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </div>

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <a href="/" style={{ fontSize: 11, color: "var(--muted)", letterSpacing: "0.1em" }}>← Siteye Dön</a>
        </div>
      </div>
    </div>
  );
}
